export enum DeliveryForDateStatus {
  PENDING = 0, // not delivered, has delivery date
  DELIVERED = 1, // delivered, not confirmed
  CONFIRMED = 2, // confirmed
  REFUNDED = 3, // refund requested
  ERROR = 4, // 
}
